

export default{
    install(Vue){
        Vue.prototype.$colors = {
            yText: '#fec200',
            blackBg:'#2b2b2b',
            
        }
    }
}